<template>
  <div class="EditProgram">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">節目詳情</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">影音</li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'AdminProgramList' }"
                  >節目列表</router-link
                >
              </li>
              <li class="breadcrumb-item active">節目詳情</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="b-video-thumbnail w-100">
                      <i style="color: red">*</i
                      ><label for="b-programme-image"
                        >節目封面（建議尺寸: 1280*720）</label
                      >
                      <el-upload
                        style="border: 1px solid #dcdfe6; margin-right: 37px"
                        class="avatar-uploader"
                        :action="uploadImageUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                      >
                        <img
                          v-if="imageUrl"
                          :src="imageUrl"
                          style="width: 305px"
                        />
                        <!-- class="avatar" -->
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                  </div>
                  <div class="col-sm-8">
                    <el-form
                      :model="editmodel"
                      ref="editmodel"
                      :rules="editrules"
                      label-width="120px"
                    >
                      <el-form-item label="節目名稱" prop="sgL_Program_Name">
                        <el-input
                          v-model="editmodel.sgL_Program_Name"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="節目簡介"
                        prop="sgL_Program_NameDesc"
                      >
                        <el-input
                          type="textarea"
                          rows="3"
                          v-model="editmodel.sgL_Program_NameDesc"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="節目類型(多選)">
                        <el-select
                          v-model="editmodel.sgL_Program_ParanIdLst"
                          multiple
                          placeholder="請選擇"
                        >
                          <el-option
                            v-for="(type) in initdata.typelist"
                            :label="type.sgL_Program_Name"
                            :key="type.id"
                            :value="type.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="製作年份">
                        <el-date-picker
                          v-model="editmodel.sgL_SetUpTime"
                          type="month"
                          placeholder="製作年份"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="製作狀態" prop="sgL_SetUpStatus">
                        <el-select
                          v-model="editmodel.sgL_SetUpStatus"
                          placeholder="請選擇"
                        >
                          <el-option label="未完結" value="0"></el-option>
                          <el-option label="已完結" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="公開狀態" prop="sgL_OpenStatus">
                        <el-select
                          v-model="editmodel.sgL_OpenStatus"
                          placeholder="請選擇"
                        >
                          <el-option label="顯示" value="1"></el-option>
                          <el-option label="隱藏" value="0"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-input
                          type="hidden"
                          v-model="editmodel.id"
                        ></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="submitForm('editmodel')"
                          >保存</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  name: "EditProgram",
  data() {
    return {
      imageUrl: "",
      uploadImageUrl:
        // "http://210.21.243.82:47097/api/TokenAuth/UploadImg/Upload/FormImg?Type=program",
        "https://api.soonnet.org/api/TokenAuth/UploadImg/Upload/FormImg?Type=program",
      editmodel: {
        sgL_ImageId: 0,
        sgL_LogImage: null,
        sgL_Program_Name: "",
        sgL_Program_NameDesc: "",
        sgL_Program_ParanIdLst: [],
        sgL_UpdateTime: null,
        sgL_SetUpTime: null,
        sgL_OpenStatus: null,
        sgL_SetUpStatus: null,
        browse_Count: 0,
        praise_Count: 0,
        collect_Count: 0,
        share_Count: 0,
        id: null,
      },
      //初始实体数据
      initdata: {
        typelist: [], //节目类型
      },
      editrules: {
        //实体限定数据规则
        sgL_Program_Name: [
          {
            required: true,
            message: "請輸入節目名稱",
            trigger: "blur",
          },
          {
            min: 2,
            max: 100,
            message: "長度在 2 到 100 個字符",
            trigger: "blur",
          },
        ],
        sgL_SetUpStatus: [
          {
            required: true,
            message: "請選擇製作狀態",
            trigger: "change",
          },
        ],
        sgL_OpenStatus: [
          {
            required: true,
            message: "請選擇公開狀態",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeMount() {
    let admin = this.$store.getters.getAdminUser;
    let permission = this.$store.getters.getPermission;
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  created() {
    let Id = this.$route.query.Id;
    //编辑时
    if (Id != undefined) {
      this.GetProgramModel(Id);
    }
    this.GetTypelist();
  },
  mounted() {},
  methods: {
    //加载
    async GetProgramModel(Id) {
      let params = {
        Id: Id,
      };
      this.$api.VideoApi.GetAdminProgramSingle(params).then((res) => {
        this.editmodel = res.data.result;
        this.editmodel.sgL_SetUpStatus = this.editmodel.sgL_SetUpStatus.toString();
        this.editmodel.sgL_OpenStatus = this.editmodel.sgL_OpenStatus.toString();
        if (
          res.data.result.sgL_LogImage != null &&
          res.data.result.sgL_LogImage != ""
        ) {
          this.imageUrl = res.data.result.sgL_LogImage;
        }
      });
    },
    //得到所有节目类型，加载多选下拉框
    async GetTypelist() {
      let params = { SGL_Program_Type: 1 };
      this.$api.VideoApi.GetAdminProgramList(params).then((result) => {
        this.initdata.typelist = result.data.result.items;
      });
    },
    //添加提交
    submitForm(formName) {
      if (this.editmodel.sgL_ImageId <= 0) {
        Message({
          type: "error",
          message: "請選擇封面圖片",
        });
        return false;
      }
      let msg = "";
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            sgL_ImageId: this.editmodel.sgL_ImageId,
            sgL_Program_Name: this.editmodel.sgL_Program_Name,
            sgL_Program_ParanIdLst: this.editmodel.sgL_Program_ParanIdLst,
            sgL_Program_Type: 0,
            sgL_OpenStatus: this.editmodel.sgL_OpenStatus,
            sgL_SetUpTime: this.editmodel.sgL_SetUpTime,
            sgL_SetUpStatus: this.editmodel.sgL_SetUpStatus,
            sgL_Program_NameDesc: this.editmodel.sgL_Program_NameDesc,
          };
          if (this.editmodel.id != null) {
            //修改
            params.id = this.editmodel.id;
            this.$api.VideoApi.EditAdminProgram(params).then((res) => {
              if (res.data.success == true) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
                this.$router.push({ name: "AdminProgramList" });
              } else {
                Message({
                  type: "error",
                  message: res.data.error.message,
                });
              }
            });
          } else {
            //添加
            this.$api.VideoApi.AddAdminProgram(params).then((res) => {
              if (res.data.success == true) {
                Message({
                  type: "success",
                  message: "添加成功",
                });
                this.$router.push({ name: "AdminProgramList" });
              } else {
                Message({
                  type: "error",
                  message: res.data.error.message,
                });
              }
            });
          }
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.editmodel.sgL_ImageId = res.result.uploadId;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !ispng) {
        this.$message.error("上传封面图片只能是 JPG /png格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传封面图片大小不能超过 2MB!");
      }
      return (isJPG || ispng) && isLt2M;
    },
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  display: inherit;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminVideo/EditProgram.vue